/** Las cadenas del chrome. La RESPUESTA sigue el idioma de la pregunta; esto sigue al interruptor. */
import type { Idioma } from "./tipos";

export const TEXTOS = {
  en: {
    titulo: "TIM AI Agent",
    subtitulo: "Technical Innovation HUB",
    sintetico: "Synthetic demo data",
    sinteticoLargo: "All figures come from synthetic data with Essity's structure. No figure is real.",
    procedencia: { sintetico: "Synthetic", real: "Real Essity data", mixto: "Mixed data" },
    procedenciaLarga: {
      sintetico: "Synthetic demo data with Essity's structure. No figure is real.",
      real: "Real Essity data, internal use. It does not leave this screen without authorisation.",
      mixto: "Crosses real Essity data with synthetic data. A figure spanning both is not a real measurement — read the card's caveats before quoting it.",
    },
    nuevaConversacion: "New conversation",
    conversaciones: "Conversations",
    sinConversaciones: "No conversations yet",
    fuentes: "Data sources",
    owner: "Owner",
    sistema: "System",
    disponible: "Available",
    asumida: "assumed",
    asumidaLargo: "assumed — not declared on the client's slide",
    preguntar: "Ask about specifications, quality, complaints, ME% or LCA…",
    enviar: "Send",
    detener: "Stop",
    sugerencias: "Try one of the questions from the brief",
    evidencia: "Evidence",
    verTabla: "Show table",
    ocultarTabla: "Hide table",
    filas: "rows",
    nivel: "Level",
    confianza: "Confidence",
    corte: "Data cutoff",
    fuente: "Source",
    usadas: "rows used",
    exportarMd: "Export Markdown",
    exportarHtml: "Export brief",
    util: "Helpful",
    noUtil: "Not helpful",
    validar: "Validated by a specialist",
    validarAyuda: "Saves the judgement of this answer to the learning base. Figures are never kept.",
    autor: "Your name",
    comentario: "What did you confirm or correct?",
    guardar: "Save",
    guardado: "Saved to the learning base",
    coste: "cost",
    rondas: "rounds",
    modelo: "model",
    degradado: "template fallback",
    reintento: "figures rechecked",
    razonamiento: "Reasoning",
    paso: "step",
    pasos: "steps",
    herramienta: "tool",
    herramientas: "tools",
    ocultar: "Hide",
    grafico: "Chart",
    tabla: "Table",
    exportar: "Export",
    comoAyudo: "How can I help?",
    verificar: "Always verify important figures before making decisions.",
    // El descargo permanente ya no puede ser una frase fija: con dato real de Essity dentro,
    // «Data is synthetic» es literalmente falso, y es la línea que más gente lee.
    verificarOrigen: { sintetico: "Data is synthetic.", real: "Contains real Essity data — internal use.",
                       mixto: "Mixes real Essity data with synthetic data — check each card." },
    analisis: "Analysis",
    administracion: "Administration",
    agente: "Agent",
    catalogo: "Sources",
    historial: "History",
    colapsar: "Collapse",
    intro: "Ask about specifications, quality data from both laboratories, process capability and ME%, consumer complaints or life-cycle assessment — or pick one of the questions from the brief.",
    pensando: "Thinking…",
    revisando: "Checking figures…",
    borrar: "Delete",
    tema: "Theme",
    idioma: "Language",
    cerrar: "Close",
    niveles: { calculado: "calculated", agregado: "aggregated", citado: "quoted", derivado: "derived" },
    confianzas: { alta: "high", media: "medium", baja: "low" },
    sinDatos: "no data",
    total: "Total",
    pctDelTotal: "% of total",
    accesoTitulo: "Restricted access",
    accesoIntro: "Technical Innovation HUB agent for Essity Consumer Tissue. Enter your personal access token to continue — your name appears inside, next to Sign out.",
    accesoEtiqueta: "Your access token",
    accesoEntrar: "Sign in",
    accesoEntrando: "Signing in…",
    accesoMal: "That token is not valid.",
    accesoCaido: "Could not reach the server. Try again.",
    accesoSintetico: "All data in this demo is synthetic: it has Essity's structure and no figure is real.",
    accesoSalir: "Sign out",
    sesionDe: "Signed in as",
    abrirFicha: "Open the PLM fact sheet (PDF):",
    sinMedicion: "not measured this month",
    fichaVisor: "PLM fact sheet",
    abrirInforme: "Open the mill quality report (PDF):",
    informeVisor: "Mill quality report",
    fichaNuevaPestana: "Open in a new tab",
    abrirMenu: "Open menu",
    cerrarMenu: "Close menu",
    mes: "Month",
    error: "Something failed",
    verMas: "more",
  },
  es: {
    titulo: "TIM AI Agent",
    subtitulo: "Technical Innovation HUB",
    sintetico: "Datos sintéticos de demostración",
    sinteticoLargo: "Todas las cifras salen de datos sintéticos con la estructura de Essity. Ninguna es real.",
    procedencia: { sintetico: "Sintético", real: "Dato real de Essity", mixto: "Dato mixto" },
    procedenciaLarga: {
      sintetico: "Datos sintéticos de demostración con la estructura de Essity. Ninguna cifra es real.",
      real: "Datos reales de Essity, de uso interno. No salen de esta pantalla sin autorización.",
      mixto: "Cruza dato real de Essity con dato sintético. Una cifra que abarca los dos no es una medición real: lee las salvedades de la tarjeta antes de citarla.",
    },
    nuevaConversacion: "Nueva conversación",
    conversaciones: "Conversaciones",
    sinConversaciones: "Todavía no hay conversaciones",
    fuentes: "Fuentes de datos",
    owner: "Owner",
    sistema: "Sistema",
    disponible: "Disponible",
    asumida: "asumida",
    asumidaLargo: "asumida — no figura en la slide del cliente",
    preguntar: "Pregunta por especificaciones, calidad, quejas, ME% o LCA…",
    enviar: "Enviar",
    detener: "Detener",
    sugerencias: "Prueba una de las preguntas del brief",
    evidencia: "Evidencia",
    verTabla: "Ver tabla",
    ocultarTabla: "Ocultar tabla",
    filas: "filas",
    nivel: "Nivel",
    confianza: "Confianza",
    corte: "Corte de datos",
    fuente: "Fuente",
    usadas: "filas usadas",
    exportarMd: "Exportar Markdown",
    exportarHtml: "Exportar brief",
    util: "Útil",
    noUtil: "No útil",
    validar: "Validado por un especialista",
    validarAyuda: "Guarda el juicio de esta respuesta en la learning base. Las cifras nunca se conservan.",
    autor: "Tu nombre",
    comentario: "¿Qué confirmaste o corregiste?",
    guardar: "Guardar",
    guardado: "Guardado en la learning base",
    coste: "coste",
    rondas: "rondas",
    modelo: "modelo",
    degradado: "respuesta de plantilla",
    reintento: "cifras revisadas",
    razonamiento: "Razonamiento",
    paso: "paso",
    pasos: "pasos",
    herramienta: "herramienta",
    herramientas: "herramientas",
    ocultar: "Ocultar",
    grafico: "Gráfico",
    tabla: "Tabla",
    exportar: "Exportar",
    comoAyudo: "¿En qué te ayudo?",
    verificar: "Verifica siempre las cifras importantes antes de decidir.",
    verificarOrigen: { sintetico: "Los datos son sintéticos.", real: "Contiene datos reales de Essity — uso interno.",
                       mixto: "Mezcla datos reales de Essity con sintéticos — revisa cada tarjeta." },
    analisis: "Análisis",
    administracion: "Administración",
    agente: "Agente",
    catalogo: "Fuentes",
    historial: "Historial",
    colapsar: "Colapsar",
    intro: "Pregunta por especificaciones, datos de los dos laboratorios, capacidad de proceso y ME%, quejas de consumidores o ciclo de vida — o elige una de las preguntas del brief.",
    pensando: "Pensando…",
    revisando: "Revisando cifras…",
    borrar: "Borrar",
    tema: "Tema",
    idioma: "Idioma",
    cerrar: "Cerrar",
    niveles: { calculado: "calculado", agregado: "agregado", citado: "citado", derivado: "derivado" },
    confianzas: { alta: "alta", media: "media", baja: "baja" },
    sinDatos: "sin datos",
    total: "Total",
    pctDelTotal: "% del total",
    accesoTitulo: "Acceso restringido",
    accesoIntro: "Agente del Technical Innovation HUB para Essity Consumer Tissue. Escribe tu token personal para continuar — tu nombre aparece dentro, junto a Salir.",
    accesoEtiqueta: "Tu token de acceso",
    accesoEntrar: "Entrar",
    accesoEntrando: "Entrando…",
    accesoMal: "Ese token no es válido.",
    accesoCaido: "No se pudo contactar con el servidor. Inténtalo otra vez.",
    accesoSintetico: "Todos los datos de este demo son sintéticos: tienen la estructura de Essity y ninguna cifra es real.",
    accesoSalir: "Salir",
    sesionDe: "Dentro como",
    abrirFicha: "Abrir la ficha de PLM (PDF):",
    sinMedicion: "sin medición ese mes",
    fichaVisor: "Ficha de PLM",
    abrirInforme: "Abrir el informe de calidad de planta (PDF):",
    informeVisor: "Informe de calidad de planta",
    fichaNuevaPestana: "Abrir en una pestaña nueva",
    abrirMenu: "Abrir menú",
    cerrarMenu: "Cerrar menú",
    mes: "Mes",
    error: "Algo falló",
    verMas: "más",
  },
} as const;

/** Los seis dominios de herramientas, en legible.
 *
 * El evento que abre una herramienta llega ANTES de que el modelo termine de escribir sus
 * argumentos, así que durante unos segundos no hay etiqueta que mostrar. Sin esto se veía
 * «Thinking… tim_especificaciones» —el nombre técnico— justo en la espera más larga del turno. */
export const DOMINIOS: Record<string, { es: string; en: string }> = {
  tim_especificaciones: { es: "Consultando especificaciones y laboratorios…", en: "Checking specifications and laboratories…" },
  tim_calidad: { es: "Revisando calidad medida y percepción…", en: "Reviewing measured quality and perception…" },
  tim_operaciones: { es: "Leyendo la fábrica y cruzando métricas…", en: "Reading the factory and cross-checking metrics…" },
  tim_consumidor: { es: "Mirando quejas e impacto en ventas…", en: "Looking at complaints and sales impact…" },
  tim_resumen: { es: "Armando el panorama de los 12 meses…", en: "Building the 12-month picture…" },
  tim_sustentabilidad: { es: "Consultando ciclo de vida y acciones…", en: "Checking life cycle and actions…" },
};

export function etiquetaDominio(tool: string, idioma: Idioma): string {
  const base = tool.split("(")[0] ?? tool;
  return DOMINIOS[base]?.[idioma] ?? "";
}

export type Textos = (typeof TEXTOS)["en"];

export function t(idioma: Idioma): Textos {
  return TEXTOS[idioma] as Textos;
}

export function bi(valor: { es: string; en: string } | string | undefined | null, idioma: Idioma): string {
  if (!valor) return "";
  if (typeof valor === "string") return valor;
  return valor[idioma] || valor.en || valor.es || "";
}
